import { Dispatch, SetStateAction } from 'react'

export const toggleExpand = (element: HTMLElement, setShow: Dispatch<SetStateAction<boolean>>) => {
  if (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth) {
    setShow(true)
  } else {
    setShow(false)
  }
}
